const bsc_chainId = 56;
const bsc_usdt = '0x55d398326f99059fF775485246999027B3197955';
const bsc_act = '0x2de33F9DC49Ab68775160921E043d7DFC4BBB2B7';

// const bsc_testnet_usdt = '0xffBfE5fcbecED10b385601Cc78fECfc33BeE237b';
// const bsc_testnet_act = '0xB164cdd83b5d07ED91cd3E09Be983d5fee86C6DA';

export const pancakeSwapBuyUrl = `https://pancakeswap.finance/swap?inputCurrency=${bsc_usdt}&outputCurrency=${bsc_act}&chainId=${bsc_chainId}`;
// export const testnetPancakeSwapBuyUrl = `https://pancakeswap.finance/swap?chain=bscTestnet&inputCurrency=${bsc_testnet_usdt}&outputCurrency=${bsc_testnet_act}`;
